/**
 * @generated SignedSource<<d7bc642e50eb4ef7fc4976076334590e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TimeRange = {
  end?: string | null;
  start?: string | null;
};
export type ProjectFailureAnalysisPageQuery$variables = {
  timeRange: TimeRange;
};
export type ProjectFailureAnalysisPageQuery$data = {
  readonly projects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly ann_closed_qa: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_compile: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_failure: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_helpfulness: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_instruction: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_latency: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_prompt: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_refusal: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_security: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_sql: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly ann_syntax: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly id: string;
        readonly latencyMsP50: number | null;
        readonly name: string;
        readonly piiAnnotation: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly traceAnnotationSummary: {
          readonly count: number;
          readonly meanScore: number | null;
        } | null;
        readonly traceCount: number;
      };
    }>;
  };
};
export type ProjectFailureAnalysisPageQuery = {
  response: ProjectFailureAnalysisPageQuery$data;
  variables: ProjectFailureAnalysisPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "timeRange"
  }
],
v1 = {
  "kind": "Variable",
  "name": "timeRange",
  "variableName": "timeRange"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meanScore",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 100
      }
    ],
    "concreteType": "ProjectConnection",
    "kind": "LinkedField",
    "name": "projects",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v1/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "traceCount",
                "storageKey": null
              },
              {
                "alias": "latencyMsP50",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "probability",
                    "value": 0.5
                  },
                  (v1/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "latencyMsQuantile",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "General_Correctness"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "traceAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "piiAnnotation",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "pii_detection"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "ann_instruction",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Instruction_Compliance"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "ann_prompt",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Prompt_Adherence"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "ann_failure",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Failure_Rates"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "ann_latency",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Span_Latency"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "ann_syntax",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Syntax_Correctness"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "ann_compile",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Compilation_Success"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "ann_security",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Security_Vulnerabilities"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "ann_helpfulness",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Helpfulness"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "ann_closed_qa",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Model-Graded Closed QA"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "ann_sql",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Sql_Evaluation"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": "ann_refusal",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "annotationName",
                    "value": "Is-Refusal"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "AnnotationSummary",
                "kind": "LinkedField",
                "name": "spanAnnotationSummary",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "projects(first:100)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectFailureAnalysisPageQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectFailureAnalysisPageQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "6a082922feee9aa55ea1f1f51f4c70da",
    "id": null,
    "metadata": {},
    "name": "ProjectFailureAnalysisPageQuery",
    "operationKind": "query",
    "text": "query ProjectFailureAnalysisPageQuery(\n  $timeRange: TimeRange!\n) {\n  projects(first: 100) {\n    edges {\n      node {\n        id\n        name\n        traceCount(timeRange: $timeRange)\n        latencyMsP50: latencyMsQuantile(probability: 0.5, timeRange: $timeRange)\n        traceAnnotationSummary(annotationName: \"General_Correctness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        piiAnnotation: spanAnnotationSummary(annotationName: \"pii_detection\", timeRange: $timeRange) {\n          count\n          meanScore\n        }\n        ann_instruction: spanAnnotationSummary(annotationName: \"Instruction_Compliance\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_prompt: spanAnnotationSummary(annotationName: \"Prompt_Adherence\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_failure: spanAnnotationSummary(annotationName: \"Failure_Rates\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_latency: spanAnnotationSummary(annotationName: \"Span_Latency\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_syntax: spanAnnotationSummary(annotationName: \"Syntax_Correctness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_compile: spanAnnotationSummary(annotationName: \"Compilation_Success\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_security: spanAnnotationSummary(annotationName: \"Security_Vulnerabilities\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_helpfulness: spanAnnotationSummary(annotationName: \"Helpfulness\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_closed_qa: spanAnnotationSummary(annotationName: \"Model-Graded Closed QA\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_sql: spanAnnotationSummary(annotationName: \"Sql_Evaluation\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n        ann_refusal: spanAnnotationSummary(annotationName: \"Is-Refusal\", timeRange: $timeRange) {\n          meanScore\n          count\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "22374b6c0b9937c819726c06bf6b36d3";

export default node;
